import i18n from './i18n';

export const getTranslatedMessage = (
  key: string,
  option?: Record<string, string | number> & { defaultValue?: unknown },
) => {
  return i18n.t(key, { ...option });
};
